import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { OAuthError, OAuthNeutral, OAuthSuccess } from '../../features/oauth/components'
import { z } from 'zod'
import { match } from 'ts-pattern'
import { Button, Card } from '@bpinternal/ui-kit-next'

const searchParamsSchema = z.object({
  success: z
    .boolean()
    .optional()
    .catch(() => undefined),
  errorMessage: z
    .string()
    .optional()
    .catch(() => 'undefined'),
})

export const Route = createFileRoute('/oauth/interstitial')({
  component: OAuthInterstitialPage,
  validateSearch: searchParamsSchema,
})

export function OAuthInterstitialPage() {
  const { errorMessage, success } = Route.useSearch()

  const [seconds, setSeconds] = useState(5)
  // Buffer in case window doesn't close such as in case of "Scripts may close only the windows that were opened by them."
  const [timeWithBuffersUp, setTimeWithBuffersUp] = useState(false)

  useEffect(() => {
    if (seconds > 0) {
      const timerId = setTimeout(() => {
        setSeconds(seconds - 1)
      }, 1000)

      return () => clearTimeout(timerId)
    }
    window.close()
  }, [seconds])

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeWithBuffersUp(true)
    }, 8000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="h-screen p-4">
      <Card className="flex h-full w-full flex-col items-center p-5">
        {match(success)
          .with(true, () => <OAuthSuccess />)
          .with(false, () => <OAuthError errorMessage={errorMessage} />)
          .with(undefined, () => <OAuthNeutral />)
          .exhaustive()}
        {timeWithBuffersUp ? (
          <Button onClick={() => window.close()} className="mt-auto">
            Close Window and Continue
          </Button>
        ) : (
          <>
            <div className="text-md mt-auto mb-3 text-center text-neutral-800">
              This window will automatically close in <span className="font-bold">{seconds}s</span>
            </div>
            <div className="h-2 w-full rounded-full bg-neutral-50">
              <div className="h-full w-[0%] animate-grow-right rounded-full bg-primary-500" />
            </div>
          </>
        )}
      </Card>
    </div>
  )
}
